import React from 'react';
import { LayoutDashboard, Stethoscope, Calendar, Pill, Dumbbell, BookOpen, BarChart2, Heart, LogOut } from 'lucide-react';
type Page = 'dashboard' | 'doctors' | 'appointments' | 'medications' | 'exercise' | 'journal' | 'statistics';
interface SidebarProps {
  activePage: Page;
  onNavigate: (page: Page) => void;
}
export function Sidebar({
  activePage,
  onNavigate
}: SidebarProps) {
  const navItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboard
  }, {
    id: 'doctors',
    label: 'Doctors',
    icon: Stethoscope
  }, {
    id: 'appointments',
    label: 'Appointments',
    icon: Calendar
  }, {
    id: 'medications',
    label: 'Medications',
    icon: Pill
  }, {
    id: 'exercise',
    label: 'Exercise',
    icon: Dumbbell
  }, {
    id: 'journal',
    label: 'Journal',
    icon: BookOpen
  }, {
    id: 'statistics',
    label: 'Statistics',
    icon: BarChart2
  }] as const;
  return <div className="w-64 h-screen bg-white border-r border-slate-200 flex flex-col fixed left-0 top-0 z-50" data-id="element-11">
      {/* Logo Area */}
      <div className="p-6 flex items-center gap-3" data-id="element-12">
        <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-200" data-id="element-13">
          <Heart className="w-6 h-6 text-white fill-white" data-id="element-14" />
        </div>
        <div data-id="element-15">
          <h1 className="font-bold text-slate-900 text-lg leading-tight" data-id="element-16">
            Health Center
          </h1>
          <p className="text-xs text-slate-500 font-medium" data-id="element-17">Wellness Journey</p>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-4 space-y-1 overflow-y-auto" data-id="element-18">
        {navItems.map(item => {
        const isActive = activePage === item.id;
        return <button key={item.id} onClick={() => onNavigate(item.id as Page)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 group ${isActive ? 'bg-blue-600 text-white shadow-md shadow-blue-200' : 'text-slate-500 hover:bg-blue-50 hover:text-blue-600'}`} data-id="element-19">
              <item.icon className={`w-5 h-5 ${isActive ? 'text-white' : 'text-slate-400 group-hover:text-blue-600'}`} data-id="element-20" />
              <span className="font-medium" data-id="element-21">{item.label}</span>
            </button>;
      })}
      </nav>

      {/* User Profile */}
      <div className="p-4 border-t border-slate-100" data-id="element-22">
        <div className="flex items-center gap-3 p-3 rounded-xl bg-slate-50 hover:bg-slate-100 transition-colors cursor-pointer" data-id="element-23">
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold" data-id="element-24">
            OP
          </div>
          <div className="flex-1 overflow-hidden" data-id="element-25">
            <p className="text-sm font-bold text-slate-900 truncate" data-id="element-26">Oto Pro</p>
            <p className="text-xs text-slate-500 truncate" data-id="element-27">otopro@health.com</p>
          </div>
          <LogOut className="w-4 h-4 text-slate-400" data-id="element-28" />
        </div>
      </div>
    </div>;
}